import React from 'react';
import './ExperienceTimeline.css';

const ExperienceTimeline = ({ title, experiences }) => {
  return (
    <div className="experience-section">
      <h2 className="section-title">{title}</h2>
      
      <div className="experience-container">
        <div className="exp-axis-line"></div>

        {experiences.map((exp, index) => (
          <div 
              className="experience-item" 
              key={index}
              id={`exp-${exp.id}`}   
            >
            <div className="exp-axis">
              <div className="exp-axis-line"></div>
              <div className="exp-axis-item">
                <span className="exp-year">{exp.date}</span>
                <div className="exp-dot"></div>
              </div>
            </div>

            <div className="experience-card">
              <h3>{exp.title}</h3>
              <p>{exp.description}</p>

              {/* 渲染 sections */}
              {exp.sections && exp.sections.map((section, idx) => (
                <div key={idx} className="experience-section-item">
                  <h4>{section.heading}</h4>
                  <p>{section.content}</p>
                </div>
              ))}

              {/* 渲染 tags */}
              <div className="tags">
                {exp.tags && exp.tags.map((tag, idx) => (
                  <span className="tag" key={idx}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ExperienceTimeline;


